import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Markdown } from "@/components/site/Markdown";

export default function AdminAbout() {
  const [body, setBody] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/about").then((r) => setBody(r.data.body)); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/about", { body });
      toast.success("About page updated");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  if (body === null) return <p className="meta">Loading</p>;
  return (
    <div data-testid="admin-about-editor">
      <div className="flex items-end justify-between mb-8">
        <div><p className="meta">Page</p><h1 className="font-display text-4xl font-bold mt-1">About</h1></div>
        <button disabled={busy} onClick={save} className="bg-[var(--ink)] text-white font-ui text-sm px-5 py-2.5 hover:bg-[var(--accent)] transition-colors disabled:opacity-50" data-testid="admin-about-save-button">
          {busy ? "Saving…" : "Save"}
        </button>
      </div>
      <div className="grid gap-8 lg:grid-cols-2">
        <textarea rows={26} value={body} onChange={(e) => setBody(e.target.value)} className="w-full border border-[#CFCFCB] bg-white p-4 font-mono-ui text-[13px] leading-relaxed outline-none focus:border-[var(--ink)]" data-testid="admin-about-body-input" />
        <div className="bg-[var(--paper)] border border-[var(--rule)] p-8"><Markdown body={body} testId="admin-about-preview" /></div>
      </div>
    </div>
  );
}
